class MenuHandler {

  constructor() {
    this.menu = document.querySelector('.nav')
    this.button = document.querySelector('.burger')
    this.listen()
  }

  listen() {
    this.button.addEventListener('click', () => {
      this.button.classList.toggle('burger--open')
      this.menu.classList.toggle('nav--open')
      if (this.button.classList.contains('burger--open')) {
        document.body.style.overflow = "hidden"
      } else {
        document.body.removeAttribute('style')
      }
    })
  }


}

export default MenuHandler